(() => {
  const initializationSentinel = '__eimlessUiInitialized';
  if (window[initializationSentinel]) return;
  window[initializationSentinel] = true;

  const eventPayloadFields = {
    select_product_need: ['need_id', 'need_label'],
    open_product_comparison: [
      'source_product_handle',
      'source_product_sku',
      'target_product_handle',
      'target_product_sku',
    ],
    click_marketplace: ['product_handle', 'product_sku', 'destination'],
    add_complementary_product: [
      'source_product_handle',
      'source_product_sku',
      'target_product_handle',
      'target_product_sku',
    ],
    click_line_optin: ['product_handle', 'product_sku', 'destination'],
    select_support_channel: ['product_handle', 'product_sku', 'destination'],
    view_featured_product: ['product_handle', 'product_sku'],
  };
  const defaultInteractionTypes = {
    select_product_need: 'card_click',
    open_product_comparison: 'detail_click',
    click_marketplace: 'cta_click',
    add_complementary_product: 'add_click',
    click_line_optin: 'cta_click',
    select_support_channel: 'cta_click',
    view_featured_product: 'detail_click',
  };

  const toDatasetKey = (key) => key.replace(/_([a-z])/g, (_, character) => character.toUpperCase());
  const isUrl = (value) => /^(?:mailto:|tel:|\/\/|\/|#)|(?:[a-z][a-z\d+.-]*:\/\/|www\.)/i.test(value);
  const isEmail = (value) => /\b[^\s@]+@[^\s@]+\.[^\s@]+\b/.test(value);

  const addSafeValue = (payload, key, value) => {
    if (value === null || typeof value === 'undefined') return;

    const normalizedValue = typeof value === 'string' ? value.trim() : value;
    if (normalizedValue === '') return;
    if (typeof normalizedValue === 'string' && (isUrl(normalizedValue) || isEmail(normalizedValue))) return;

    payload[key] = normalizedValue;
  };

  const buildPayload = (eventName, element, overrides = {}) => {
    const payload = { schema_version: 1 };
    const pageType =
      overrides.page_type || element.dataset.pageType || document.body?.dataset.pageType || 'unknown';
    const placement = overrides.placement || element.dataset.placement || 'unspecified';
    const interactionType =
      overrides.interaction_type ||
      element.dataset.interactionType ||
      defaultInteractionTypes[eventName] ||
      'click';

    addSafeValue(payload, 'page_type', pageType);
    addSafeValue(payload, 'placement', placement);
    addSafeValue(payload, 'interaction_type', interactionType);

    eventPayloadFields[eventName].forEach((field) => {
      const datasetKey = toDatasetKey(field);
      addSafeValue(payload, field, overrides[field] ?? element.dataset[datasetKey]);
    });

    return payload;
  };

  const publishEvent = (eventName, element, overrides) => {
    if (!Object.prototype.hasOwnProperty.call(eventPayloadFields, eventName)) return;

    try {
      const publish = window.Shopify?.analytics?.publish;
      if (typeof publish !== 'function') return;

      const result = publish.call(
        window.Shopify.analytics,
        `eimless:${eventName}`,
        buildPayload(eventName, element, overrides)
      );
      if (result && typeof result.catch === 'function') {
        result.catch(() => {});
      }
    } catch (_) {
      // Analytics must never block a click, navigation, or core storefront behavior.
    }
  };

  document.documentElement.dataset.eimlessUi = 'ready';

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-eimless-event]');
    if (!target) return;

    const eventName = target.dataset.eimlessEvent;
    publishEvent(eventName, target);
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-eimless-scroll-to-buy]');
    if (!trigger) return;
    trigger.dataset.eimlessScrollHandled = 'true';

    const purchaseArea =
      document.querySelector('.product-form__buttons') ||
      document.querySelector('product-form') ||
      document.querySelector('[id^="ProductInfo-"]');

    if (purchaseArea) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      purchaseArea.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });

      window.requestAnimationFrame(() => {
        const focusTarget = purchaseArea.querySelector('button:not([disabled]), input:not([disabled]), select:not([disabled])');
        focusTarget?.focus({ preventScroll: true });
      });
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const { html, sectionId, variant } = data || {};
      if (!variant) return;

      const priceSource = html
        ?.getElementById(`price-${sectionId}`)
        ?.querySelector('.price-item--sale, .price-item--regular');

      document.querySelectorAll('.eimless-mobile-buybar').forEach((bar) => {
        const price = bar.querySelector('.eimless-mobile-buybar__price');
        const button = bar.querySelector('[data-eimless-scroll-to-buy]');

        if (priceSource && price) {
          price.textContent = priceSource.textContent.trim();
        }

        if (button) {
          button.disabled = !variant.available;
          button.textContent = variant.available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
        }
      });
    });
  }

  const featuredProduct = document.querySelector('[data-eimless-featured-impression]');
  if (featuredProduct) {
    let impressionPublished = false;
    const publishImpression = () => {
      if (impressionPublished) return;
      impressionPublished = true;
      publishEvent('view_featured_product', featuredProduct, { interaction_type: 'impression' });
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.25)) {
            observer.disconnect();
            publishImpression();
          }
        },
        { threshold: 0.25 }
      );
      observer.observe(featuredProduct);
    }
  }
})();
